module.exports = __webpack_public_path__ + "img/logo-full.98727c55.png";